import { render, staticRenderFns } from "./showAdminModel.vue?vue&type=template&id=13e5c116&"
import script from "./showAdminModel.vue?vue&type=script&lang=js&"
export * from "./showAdminModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports